import { Component } from '@angular/core'

@Component({
  standalone: true,
  selector: 'app-progress-indefinite',
  // Rendered on every device. This used to be wrapped in *ngIf="isDesktop",
  // which left an empty 0-height host on iPad — every widget using this loader
  // showed nothing at all while it was fetching.
  template: `
    <div class="animation"></div>
  `,
  styleUrls: ['./indefinite.scss']
})

export class ProgressIndefinite {
}
